export default {
  open: false,
  currentPassword: '',
  password: '',
  confirmPassword: '',
  loading: false,
  errors: {},
};
